import { useMemo } from 'react';

import { getInstalledApp } from './installedApp';

import type { AppSlug } from './installedApp';

/**
 * The running installed app, or null in a browser tab.
 *
 * Stable for the life of the page: the marker is captured once at init and never
 * re-read, so this needs no state and never re-renders on navigation.
 */
export function useInstalledApp(): AppSlug | null {
  return useMemo(() => getInstalledApp(), []);
}
